module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rank mt120",
    style: ({
      minWidth: _vm.minWidth + 'px'
    }),
    on: {
      "click": _vm.moreInfoHide
    }
  }, [(_vm.pcLoading) ? _c('img', {
    staticClass: "loading",
    attrs: {
      "src": require("./../assets/img/loading.gif")
    }
  }) : _c('div', [_c('div', {
    staticClass: "tabContent viewport"
  }, [_c('div', {
    staticClass: "tabtitleBox"
  }, [_c('img', {
    staticClass: "morePc",
    attrs: {
      "src": require("./../assets/img/morePc.png")
    },
    on: {
      "click": _vm.moreToggleInfoShow
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "tabConTitle",
    attrs: {
      "title": _vm.currentTitle
    }
  }, [_vm._v(_vm._s(_vm.currentTitle))]), _vm._v(" "), (_vm.pcmoreInfo) ? _c('div', {
    staticClass: "moreInfo",
    on: {
      "click": _vm.moreInfoShow
    }
  }, [_c('div', {
    staticClass: "pcWorkName"
  }, [_c('span', {
    staticClass: "pcWorkNameL"
  }, [_vm._v("作业名称:")]), _vm._v(" "), _c('span', {
    staticClass: "pcWorkNameR"
  }, [_vm._v(_vm._s(_vm.currentTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "pcSendDate"
  }, [_c('span', {
    staticClass: "pcWorkNameL"
  }, [_vm._v("布置时间:")]), _vm._v(" "), _c('span', {
    staticClass: "pcWorkNameR"
  }, [_vm._v(_vm._s(_vm.sendDate))])]), _vm._v(" "), _c('div', {
    staticClass: "pcEffectiveDate"
  }, [_c('span', {
    staticClass: "pcWorkNameL"
  }, [_vm._v("截止时间:")]), _vm._v(" "), _c('span', {
    staticClass: "pcWorkNameR"
  }, [_vm._v(_vm._s(_vm.effectiveDate))])]), _vm._v(" "), _c('div', {
    staticClass: "pcLeaveMessge"
  }, [_c('span', {
    staticClass: "pcWorkNameL"
  }, [_vm._v("作业留言:")]), _vm._v(" "), _c('span', {
    staticClass: "pcWorkNameR"
  }, [_vm._v(_vm._s(_vm.WorkMessage))])])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "tabConTip"
  }, [_vm._v(_vm._s(_vm.ReviceObject))]), _vm._v(" "), _c('button', {
    staticClass: "button btn-size",
    class: {
      green: _vm.stateTime == "stateGreen", gray: _vm.stateTime == "stateGray", orange: _vm.stateTime == "stateOrange"
    }
  }, [_vm._v(_vm._s(_vm.stateText))]), _vm._v(" "), (_vm.stateTime == "stateOrange") ? _c('div', {
    staticClass: "unPublish"
  }, [_c('p', {
    staticClass: "unPublishTime"
  }), _vm._v(" "), _c('p', {
    staticClass: "tabConTip"
  }, [_vm._v("距离发布时间还有：" + _vm._s(_vm.endTime))])]) : _c('div', [(_vm.stateBtn) ? _c('p', {
    staticClass: "tabConTip"
  }, [_vm._v("距离截止时间还剩：" + _vm._s(_vm.endTime))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "tabConCount clearfix"
  }, [_c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm._f("toMath")(_vm.rankStatistics.max, 2, '-')))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("最高分")])]), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm._f("toMath")(_vm.rankStatistics.min, 2, '-')))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("最低分")])]), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "tabScore"
  }, [_vm._v(_vm._s(_vm._f("toMath")(_vm.rankStatistics.average, 2, '-')))]), _vm._v(" "), _c('span', {
    staticClass: "tabScoreTip"
  }, [_vm._v("平均分")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "socreRank viewport"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rankWorkTable"
  }, [_c('rankPCWorkTable', {
    attrs: {
      "list": _vm.rankRecords,
      "unlist": _vm.unRecords,
      "hList": _vm.rankcontentList
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "socreRankTitle"
  }, [_c('li', {
    staticClass: "active"
  }, [_vm._v("\n                  成绩排名\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b1552da","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rank.vue
// module id = 1213
// module chunks = 1